module.exports = __webpack_public_path__ + "img/pic_20.f07d4229.jpg";